export const ROUTE_CATALOGUE = '/:username([a-zA-Z0-9_.]{2,30})';
export const ROUTE_NEW_ARRIVAL = '/:username([a-zA-Z0-9_.]{2,30})/new-arrival';
export const ROUTE_PRODUCT = '/:username([a-zA-Z0-9_.]{2,30})/:productId([a-zA-Z0-9]+)/:productKey/:productSignature?';
export const ROUTE_SEARCH = '/:username([a-zA-Z0-9_.]{2,30})/search';
